import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Search, X, Filter } from "lucide-react";

/**
 * Barra de filtros genérica (texto + selects) para listas largas de líneas/componentes.
 * `selects`: [{ k, placeholder, options: [{v, label}] }]. Valor "__all__" = sin filtro.
 */
export default function FiltrosBar({ value, onChange, selects = [], placeholder = "Buscar…", total, visibles, testId = "filtros" }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const activos = Object.entries(value).filter(([k, v]) => k === "q" ? !!v : (v && v !== "__all__")).length;
  const limpiar = () => onChange(Object.fromEntries(Object.keys(value).map((k) => [k, k === "q" ? "" : "__all__"])));
  return (
    <div className="flex flex-wrap items-center gap-2 mb-3" data-testid={testId}>
      <div className="relative flex-1 min-w-[200px]">
        <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-zinc-500" />
        <Input value={value.q || ""} onChange={(e) => set("q", e.target.value)} placeholder={placeholder}
          data-testid={`${testId}-q`}
          className="pl-8 h-9 bg-zinc-900/70 border-zinc-800 text-xs" />
      </div>
      {selects.map((s) => (
        <Select key={s.k} value={value[s.k] || "__all__"} onValueChange={(v) => set(s.k, v)}>
          <SelectTrigger data-testid={`${testId}-${s.k}`}
            className={`h-9 w-auto min-w-[130px] bg-zinc-900/70 border-zinc-800 text-xs ${value[s.k] && value[s.k] !== "__all__" ? "border-cyan-500/50 text-cyan-200" : ""}`}>
            <SelectValue placeholder={s.placeholder} />
          </SelectTrigger>
          <SelectContent className="bg-zinc-950 border-zinc-800 text-zinc-100">
            <SelectItem value="__all__">{s.placeholder}: todos</SelectItem>
            {s.options.map((o) => <SelectItem key={o.v} value={o.v}>{o.label}</SelectItem>)}
          </SelectContent>
        </Select>
      ))}
      <span className="text-[11px] text-zinc-500 inline-flex items-center gap-1 ml-auto" data-testid={`${testId}-conteo`}>
        <Filter className="w-3 h-3" />
        {activos > 0 ? <><b className="text-cyan-300">{visibles}</b>&nbsp;de {total}</> : <>{total}</>}
        {activos > 0 && (
          <button onClick={limpiar} data-testid={`${testId}-limpiar`}
            className="ml-2 inline-flex items-center gap-1 px-2 py-0.5 rounded border border-zinc-700 hover:border-zinc-500 text-zinc-300">
            <X className="w-3 h-3" /> Limpiar
          </button>
        )}
      </span>
    </div>
  );
}

export const uniqOptions = (arr, getV, getLabel = (v) => v) =>
  Array.from(new Map(arr.map((x) => [getV(x), getLabel(getV(x))]).filter(([v]) => v)).entries())
    .sort((a, b) => String(a[1]).localeCompare(String(b[1])))
    .map(([v, label]) => ({ v: String(v), label }));
